"use client"

import clsx from "clsx"
import { ReactNode } from "react"
import { useStickyHeaderClassName } from "src/components/layout/stickyHeader"
import { SanitySettings } from "src/data/sanity/types"

export type HeaderWrapperProps = {
  children: ReactNode
  settings?: SanitySettings
}

export function HeaderWrapper({ children }: HeaderWrapperProps) {
  const stickyHeaderClassName = useStickyHeaderClassName()

  return (
    <>
      <div className={clsx("h-20 w-full border-b bg-white", stickyHeaderClassName)}>{children}</div>
      <div className="pointer-events-none invisible h-20 w-full" />
    </>
  )
}
